import { useSelector } from '/druid/internal/WebChatReduxContext';

export default function useConnectivityStatus(): [string] {
  return [useSelector(({ connectivityStatus }) => connectivityStatus)];
}
